// PageVisibilityHandler.jsx
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { NULL_FUNCTION } from '../resource/defaults.js';

function isDocumentVisible() {
  return !document.hidden;
}

export const PageVisibilityHandler = ({
  setIsBrowserTabVisible = NULL_FUNCTION,
}) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsBrowserTabVisible({ isBrowserTabVisible: isDocumentVisible() });
    };

    const handlePageHide = () => {
      setIsBrowserTabVisible({ isBrowserTabVisible: false });
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handlePageHide);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [setIsBrowserTabVisible]);

  return null;
};

PageVisibilityHandler.propTypes = {
  setIsBrowserTabVisible: PropTypes.func,
};

export default PageVisibilityHandler;
